import { render, staticRenderFns } from "./CardFront.vue?vue&type=template&id=9f1ac0f8&scoped=true&"
import script from "./CardFront.vue?vue&type=script&lang=js&"
export * from "./CardFront.vue?vue&type=script&lang=js&"
import style0 from "./CardFront.vue?vue&type=style&index=0&id=9f1ac0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1ac0f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
